import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MessagingService } from 'src/app/services/messaging.service';
import { error } from 'console';

@Component({
  selector: 'app-claim-fellowship',
  templateUrl: './claim-fellowship.component.html',
  styleUrls: ['./claim-fellowship.component.css']
})
export class ClaimFellowshipComponent implements OnInit {
  product;
  objArr;
  form: FormGroup;
  title = "Claim a Ministry"
  route = '/claim-list/profile'
  prefixes
  connections
  submitted = false
  errorMessage
  showConnection = false
  coverPhoto
  uploadedFile: Array<object> = []
  reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  phoneno = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/
  constructor( private router: Router, private authService: AuthservicesService, private formBuilder: FormBuilder) {
  }

  ngOnInit() {

    this.errorMessage = environment.errorMessage
    this.prefixes = environment.prefix
    this.connections = environment.connections

    let data = history.state.value;
    if (data != undefined) {
      this.product = data
      this.objArr = {
        id: (this.product?.id) ? this.product?.id : "",
        name: (this.product.name) ? this.product.name : '',
        photo: (this.product?.photo) ? this.product?.photo : ''

      }
    }

    this.form = this.formBuilder.group({
      title: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      ravelUsername: [''],
      organization: this.formBuilder.group({
        bridgeNumber: [''],
        telephone: ['', Validators.pattern(this.phoneno)],
        ein: ['', Validators.required],
        website: [''],
        guidedProfile: ['']
      }),
      documents: [''],
      RoleDescription: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      community: [''],
      contact: ['', [Validators.required, Validators.pattern(this.phoneno)]],
      website: ['', Validators.required],
      connection: this.formBuilder.group({
        title: [''],
        type: ['', Validators.required],
        email: [''],
        name: [''],
        phone: ['']
      }),
      isAutherized: [false, Validators.requiredTrue],
      isAgreed: [false, Validators.requiredTrue],
    });
  }

  get f() { return this.form.controls; }

  onChange(e) {
    let connection = this.form.get('connection')

    if (e != 'staff' && e != "") {
      this.showConnection = true;
      connection.get('email').setValidators([Validators.required, Validators.email])
      connection.get('phone').setValidators([Validators.required])
      connection.get('name').setValidators([Validators.required])
      connection.get('title').setValidators([Validators.required])
      connection.get('type').setValidators([Validators.required])
    }
    else {
      this.showConnection = false;
      connection.get('email').setValidators(null)
      connection.get('phone').setValidators(null)
      connection.get('name').setValidators(null)
      connection.get('title').setValidators(null)

      connection.get('email').setValue('')
      connection.get('phone').setValue('')
      connection.get('name').setValue('')
      connection.get('title').setValue('')
    }
    connection.get('email').updateValueAndValidity()
    connection.get('phone').updateValueAndValidity()
    connection.get('name').updateValueAndValidity()
    connection.get('title').updateValueAndValidity()
    connection.get('type').updateValueAndValidity()
  }




  onCheckbox(event) {
    if (event.target.checked) {
      this.form.get('website').clearValidators()

    }
    else {
      this.form.get('website').setValidators([Validators.required, Validators.pattern(this.reg)])

    }
    this.form.get('website').updateValueAndValidity()

  }


  uploadBanner(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadedFile = event.target.files[0];
      const formData = new FormData();
      formData.append('image', file, file.name);
      formData.append('imageType', 'coverImage');
      this.authService
        .upload(formData)
        .subscribe(
          data => {
            this.coverPhoto = environment.basePath + data['data'].url;
            this.form.get('documents').setValue(this.coverPhoto)
          },
          error => {
            this.authService.successMessage(error.error.message, 'error')
          }
        );
    }
    // else {
    //   this.authService.successMessage('Please upload a photo', 'warning')
    // }
  }

  makeid() {
    let length = 100;
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }


  onSubmit() {

    let website = this.form.get('website').value;
    let org = this.form.get('organization');
    org.get('website').setValue(website)

    let formObj = this.form.value
    formObj['community'] = this.product?.id
    formObj['deviceId'] = localStorage.getItem('deviceid') || this.makeid();
    delete formObj['website']

    this.submitted = true;
    if (this.form.invalid) {
      console.log("object");
      this.authService.scrollToError();
      return;
    }
    this.authService.claimCommunity(formObj).subscribe((res: any) => {
      this.messageAlert(res.message, 'success')
      this.router.navigate(['/fellowship-directory'])
    },
      error => {
        this.messageAlert(error.error.message, 'error')
      })
  }



  messageAlert(message, type) {
    this.authService.successMessage(message, type)
  }

  onNavigate() {
    window.open("https://www.guidestar.org", "_blank");
  }

  openAgree() {
    window.open("https://ravel.faith/policies/ravel-terms/", "_blank");
  }

}




